export const ActionTypes = {
    SET_ACTION_ID: "SET_ACTION_ID",
};